import { toast } from "sonner";
import { formatApiError } from "./formatApiError";

/** Toast d'erreur API traduit (FR/EN via formatApiError). */
export function toastApiError(error, fallbackCode = "GENERIC_ERROR") {
  toast.error(formatApiError(error, fallbackCode));
}
